export { CatchBoundary, ErrorBoundary, default, links } from "/Users/huffn/dev/repos/personal/wild-beyond-witchlight/app/root.jsx";